import useApiMutation from 'shared/hooks/use-api-mutation';

const useReorderProducts = () => {
  return useApiMutation({
    url: '/products/reorder-indexes',
    method: 'PATCH',
    errorTitle: 'Erro ao ordenar produtos',
    successTitle: 'Ordenar produtos',
    successMessage: 'Ordenação atualizada com sucesso',
    redirectUrl: '/menu/products',
  });
};

export default useReorderProducts;
